// @ts-nocheck

export const StreamModes = {
  MATCH: 'MATCH',
  TV: 'TV',
};
